import React from 'react';
import styles from './NextButton.module.css';


export default function NextButton({ handleClick }) {
  if (handleClick) {
    return (
      <div className={styles.buttonContainer}>
        <button type="submit" onClick={handleClick} className={styles.nextButton}>Next</button>
      </div>
    );
  } else {
    return (
      <div className={styles.buttonContainer}>
        <button type="submit" className={styles.nextButton}>Next</button>
      </div>
    );
  }

};